export * from './text-model-resolver-service';
